import React, { Component } from 'react';

class BooleanCellTrueOnlyTemplate extends Component {
    constructor(props){
        super();
        
        this.props = props;
    }

    render(){
        return (
            <td>
                <div className="type--center">
                    {this.props.dataItem[this.props.field] ? <i className="u-icon u-icon--sml u-icon--active"></i> : null}
                </div>
            </td>
        );
    }
}

export default BooleanCellTrueOnlyTemplate;